import 'angular';

import { downgradeComponent } from '@angular/upgrade/static';

import { CopyToClipboardDirective } from './copy-to-clipboard/copy-to-clipboard.component';
import { IconComponent }            from './icon/icon.component';
import { ListBoxComponent }         from './list-box/list-box.component';

angular.module('app-lite.shared.components', [])
  .config(['$provide', $provide => {
    $provide.decorator('worCopyToClipboardDirective', ['$delegate', ( $delegate : ng.ISCEDelegateProvider ) => {
      $delegate[0].restrict = 'EA';

      return $delegate;
    }]);
  }])
  .directive('worCopyToClipboard', downgradeComponent({ component: CopyToClipboardDirective }) as ng.IDirectiveFactory)
  .directive('listBox', downgradeComponent({ component: ListBoxComponent }))
  .directive('worIcon', downgradeComponent({ component: IconComponent }));